import { render, staticRenderFns } from "./lessonSys.vue?vue&type=template&id=ebb291e0&scoped=true&"
import script from "./lessonSys.vue?vue&type=script&lang=js&"
export * from "./lessonSys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb291e0",
  null
  
)

export default component.exports